// Wait for the DOM to be fully loaded
document.addEventListener("DOMContentLoaded", function () {
  // Observe for #app-embed and its shadowRoot
  const observer = new MutationObserver(() => {
    const formRenderer = document.querySelector("#app-embed");
    if (formRenderer && formRenderer.shadowRoot) {
      observer.disconnect();

      // Inject custom styles
      const style = document.createElement("style");
      style.textContent = `
        ._checkboxLegend_1hja3_20,
        legend._textBody_2aowh_10._checkboxLegend_1hja3_20 {
          display: none !important;
        }
        ._checkboxField_171zd_1 ._textBody_2aowh_10 {
          font-family: var(--primary-font-body-family) !important;
          font-size: 12px !important;
          letter-spacing: 0px !important;
          line-height: 19.2px !important;
          margin-left: 12px !important;
        }
        ._selectToggleText_1yit2_25 {
          font-family: var(--primary-font-body-family) !important;
          font-size: 15px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: 160% !important;
          overflow: unset !important;
        }
        ._verticalLayout_171zd_6 {
          gap: 12px !important;
        }
        ._checkboxInput_171zd_31 {
          box-sizing: border-box !important;
          margin: 0 !important;
          accent-color: var(--color-brand-primary) !important;
          height: 24px !important;
          width: 24px !important;
        }
        ._inline_stahb_47 ._formContainer_stahb_30 {
          min-width: unset !important;
          max-width: 586px !important;
          width: 100% !important;
          min-height: var(--inline-container-min-height) !important;
        }
        form._formFieldset_1nihh_63 {
          gap: 12px !important;
        }
        button._formSubmitButton_ed7ce_82 {
          font-family: var(--primary-font-body-family) !important;
          font-size: 14px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: normal !important;
          letter-spacing: 0 !important;
          background: rgba(127, 17, 131, 1) !important;
        }
        ._formFieldContainer_1ydxd_5 #phone_number {
          padding: 22.5px 15px 7.5px 15px !important;
        }
        ._formError_1ydxd_20,
        ._error_1o4ef_1 {
          display: none !important;
        }
        .accountsContactName ._selectToggle_1yit2_25 p {
          color: var(--color-brand-secondary-light) !important;
          font-family: var(--primary-font-body-family) !important;
          font-weight: 500 !important;
          font-size: 15px !important;
          line-height: 100% !important;
          letter-spacing: 0px !important;
          max-height: 48px !important;
        }
        accountsContactName ._selectToggle_1yit2_25 p:focus-within,
        accountsContactName ._selectToggle_1yit2_25 p:focus {
          font-size: 10px !important;
        }
        ._selectToggle_1yit2_25 {
          max-height: 48px !important;
        }
        ._formFieldContainer_1ydxd_5 input {
          font-family: var(--primary-font-body-family) !important;
          line-height: 160% !important;
          font-size: 15px !important;
          letter-spacing: 0px !important;
          color: var(--color-brand-secondary) !important;
          height: 48px !important;
        }

        ._formFieldContainer_1ydxd_5 input:focus-within, ._formFieldContainer_1ydxd_5 input:focus {
          font-size: 10px !important;
        }

        ._formFieldContainer_1ydxd_5 {
           max-height: 48px !important;
        }

        label._formInputFieldLabel_1ydxd_37 {
          color: var(--color-brand-secondary-light) !important;
          font-size: 15px !important;
        }

        .accountsContactName ._selectToggle_1yit2_25 {
          font-family: var(--primary-font-body-family) !important;
        }

        label._formInputFieldLabel_1ydxd_37:focus-within,
        label._formInputFieldLabel_1ydxd_37:focus {
          font-size: 10px !important;
        }
      `;
      formRenderer.shadowRoot.appendChild(style);

      const shadowRoot = formRenderer.shadowRoot;

      // --- Group first and last name fields in a flex wrapper ---
      const lastName = shadowRoot.getElementById("last_name");
      const firstName = shadowRoot.getElementById("first_name");
      const lastNameParent = lastName ? lastName.closest("div") : null;
      const firstNameParent = firstName ? firstName.closest("div") : null;
      if (lastNameParent) lastNameParent.classList.add("last-name-group");
      if (firstNameParent) firstNameParent.classList.add("first-name-group");
      if (firstNameParent && lastNameParent) {
        const wrapper = document.createElement("div");
        wrapper.className = "name-fields-wrapper";
        wrapper.style.display = "flex";
        wrapper.style.gap = "12px";
        wrapper.style.justifyContent = "space-between";
        firstNameParent.style.width = "50%";
        lastNameParent.style.width = "50%";
        const parent = firstNameParent.parentNode;
        parent.insertBefore(wrapper, firstNameParent);
        wrapper.appendChild(firstNameParent);
        wrapper.appendChild(lastNameParent);

        // --- Group company registration and accounts contact fields ---
        const companyReg = shadowRoot.getElementById(
          "custom#company_registration_number_1"
        );
        const accountsContact = shadowRoot.getElementById(
          "custom#accounts_contact_name"
        );
        const companyRegParent = companyReg ? companyReg.closest("div") : null;
        const accountsContactParent = accountsContact
          ? accountsContact.closest("div")
          : null;
        if (companyRegParent) companyRegParent.classList.add("companyRegNo");
        if (accountsContactParent)
          accountsContactParent.classList.add("accountsContactName");
        if (companyRegParent) {
          companyRegParent.style.display = "flex";
          companyRegParent.style.flexDirection = "column";
          companyRegParent.style.width = "50%";
        }
        if (accountsContactParent) {
          accountsContactParent.style.display = "flex";
          accountsContactParent.style.flexDirection = "column";
          accountsContactParent.style.width = "50%";
        }
        if (companyRegParent && accountsContactParent) {
          const wrapper = document.createElement("div");
          wrapper.className = "companyParent";
          wrapper.style.display = "flex";
          wrapper.style.gap = "12px";
          wrapper.style.justifyContent = "space-between";
          const parent = companyRegParent.parentNode;
          parent.insertBefore(wrapper, companyRegParent);
          wrapper.appendChild(companyRegParent);
          wrapper.appendChild(accountsContactParent);
        }

        // --- Group postal code and select container fields ---
        const postalCode = shadowRoot.getElementById("custom#postal_code");
        const selectContainer = shadowRoot.querySelector(
          "._selectContainer_1yit2_6"
        );
        const postalCodeParent = postalCode ? postalCode.closest("div") : null;
        const selectContainerParent = selectContainer
          ? selectContainer.closest("div")
          : null;
        if (postalCodeParent) postalCodeParent.classList.add("companyRegNo");
        if (selectContainerParent)
          selectContainerParent.classList.add("accountsContactName");
        if (postalCodeParent && selectContainerParent) {
          const wrapper = document.createElement("div");
          wrapper.className = "companyParent";
          wrapper.style.display = "flex";
          wrapper.style.gap = "12px";
          wrapper.style.justifyContent = "space-between";
          postalCodeParent.style.width = "50%";
          selectContainerParent.style.width = "50%";
          const parent = postalCodeParent.parentNode;
          parent.insertBefore(wrapper, postalCodeParent);
          wrapper.appendChild(postalCodeParent);
          wrapper.appendChild(selectContainerParent);

          // Move select label into button for select container
          const selectContainer = shadowRoot.querySelector(
            "._selectContainer_1yit2_6"
          );
          if (selectContainer) {
            const labelP = selectContainer.querySelector("p._label_1yit2_10");
            const button = selectContainer.querySelector(
              "button._selectToggle_1yit2_25"
            );
            if (labelP && button && !button.contains(labelP)) {
              button.insertBefore(labelP, button.firstChild);
            }
          }

          // --- Group town/city and county fields ---
          const townCity = shadowRoot.getElementById("custom#towncity");
          const county = shadowRoot.getElementById("custom#county");
          const townCityParent = townCity ? townCity.closest("div") : null;
          const countyParent = county ? county.closest("div") : null;
          if (townCityParent) townCityParent.classList.add("companyRegNo");
          if (countyParent) countyParent.classList.add("accountsContactName");
          if (townCityParent && countyParent) {
            const wrapper = document.createElement("div");
            wrapper.className = "companyParent";
            wrapper.style.display = "flex";
            wrapper.style.gap = "12px";
            wrapper.style.justifyContent = "space-between";
            townCityParent.style.width = "50%";
            countyParent.style.width = "50%";
            const parent = townCityParent.parentNode;
            parent.insertBefore(wrapper, townCityParent);
            wrapper.appendChild(townCityParent);
            wrapper.appendChild(countyParent);
          }
        }
      }

      // --- Style disclaimers and add padding to first paragraph ---
      const disclaimers = shadowRoot.querySelectorAll(
        "._formDisclaimer_1nihh_33"
      );
      disclaimers.forEach((disclaimer) => {
        disclaimer.style.textAlign = "left";
        const firstP = disclaimer.querySelector("p");
        if (firstP) {
          firstP.style.paddingBottom = "12px";
        }
      });

      // --- Add margin to company name field ---
      const companyName = shadowRoot.getElementById("company_name");
      const companyNameParent = companyName ? companyName.closest("div") : null;
      if (companyNameParent) {
        companyNameParent.style.marginTop = "24px";
      }

      // --- Insert "Personal Information:" label above name fields ---
      const nameFieldsWrapper = shadowRoot.querySelector(
        ".name-fields-wrapper"
      );
      if (nameFieldsWrapper) {
        const divider = document.createElement("div");
        divider.style.width = "100%";
        divider.style.height = "1px";
        divider.style.background = "rgba(217,217,217,1)";
        divider.style.marginTop = "0";
        const infoDiv = document.createElement("div");
        infoDiv.textContent = "Personal Information:";
        infoDiv.style.fontFamily = "var(--primary-font-body-family)";
        infoDiv.style.fontWeight = "500";
        infoDiv.style.fontSize = "18px";
        infoDiv.style.lineHeight = "100%";
        infoDiv.style.letterSpacing = "0px";
        nameFieldsWrapper.parentNode.insertBefore(divider, nameFieldsWrapper);
        nameFieldsWrapper.parentNode.insertBefore(infoDiv, nameFieldsWrapper);
      }

      // --- Style all label elements with an id inside .forms_app ---
      const formsApps = shadowRoot.querySelectorAll(
        "._formFieldContainer_1ydxd_5"
      );
      formsApps.forEach((formsApp) => {
        const labels = formsApp.querySelectorAll("label[id]");
        labels.forEach((label) => {
          label.style.color = "rgba(25,25,25,1)";
          label.style.setProperty("font-family", "var(--primary-font-body-family)", "important");
          label.style.fontWeight = "500";
          label.style.fontSize = "10px";
          label.style.lineHeight = "100%";
          label.style.letterSpacing = "0px";
        });
      });

      // --- Responsive: stack .companyParent fields vertically on small screens ---
      function applyResponsiveCompanyParent() {
        if (window.innerWidth < 1269) {
          const companyParentDivs =
            shadowRoot.querySelectorAll(".companyParent");
          companyParentDivs.forEach((companyParentDiv) => {
            companyParentDiv.style.flexDirection = "column";
            const companyRegNo =
              companyParentDiv.querySelector(".companyRegNo");
            if (companyRegNo) {
              companyRegNo.style.width = "100%";
            }
            const accountsContactName = companyParentDiv.querySelector(
              ".accountsContactName"
            );
            if (accountsContactName) {
              accountsContactName.style.width = "100%";
            }
          });
        }
      }

      // --- Responsive: stack .name-fields-wrapper fields vertically on small screens ---
      function applyResponsiveNameFields() {
        if (window.innerWidth < 1269) {
          const nameFieldsWrappers = shadowRoot.querySelectorAll(
            ".name-fields-wrapper"
          );
          nameFieldsWrappers.forEach((wrapper) => {
            wrapper.style.flexDirection = "column";
            const firstNameGroup = wrapper.querySelector(".first-name-group");
            if (firstNameGroup) {
              firstNameGroup.style.width = "100%";
            }
            const lastNameGroup = wrapper.querySelector(".last-name-group");
            if (lastNameGroup) {
              lastNameGroup.style.width = "100%";
            }
          });
        }
      }

      window.addEventListener("resize", applyResponsiveCompanyParent);
      applyResponsiveCompanyParent();
      window.addEventListener("resize", applyResponsiveNameFields);
      applyResponsiveNameFields();

      // --- Custom error alert on button click if error classes are present ---
      const submitButton = shadowRoot.querySelector(
        "button._formSubmitButton_ed7ce_82"
      );

      // Move "Company Type" label <p> inside the <button> for the Company Type select field
      const companyTypeButton = shadowRoot.querySelector(
        'button._selectToggle_1yit2_25[aria-controls="custom#company_type_1-selector-dropdown"]'
      );
      if (companyTypeButton) {
        const selectContainer = companyTypeButton.closest(
          "._selectContainer_1yit2_6"
        );
        if (selectContainer) {
          selectContainer.classList.add("companyTypeName");
          const labelP = selectContainer.querySelector("p._label_1yit2_10");
          const valueSpan = companyTypeButton.querySelector("span");
          if (labelP && !companyTypeButton.contains(labelP)) {
            companyTypeButton.insertBefore(
              labelP,
              companyTypeButton.firstChild
            );
          }
          if (!shadowRoot.getElementById("company-type-style")) {
            const style = document.createElement("style");
            style.id = "company-type-style";
            style.textContent = `
              .companyTypeName ._selectToggle_1yit2_25 p {
                color: var(--color-brand-secondary-light) !important;
                font-family: var(--primary-font-body-family) !important;
                font-weight: 500 !important;
                font-size: 15px !important;
                line-height: 100% !important;
                letter-spacing: 0px !important;
                max-height: 48px !important;
                text-wrap-mode: nowrap !important;
                margin-bottom: unset !important;
              }
            `;
            shadowRoot.appendChild(style);
          }
          if (labelP && valueSpan) {
            const hideLabelIfSelected = () => {
              if (
                valueSpan.textContent &&
                valueSpan.textContent.trim() !== ""
              ) {
                labelP.style.display = "none";
              } else {
                labelP.style.display = "";
              }
            };
            const observer = new MutationObserver(hideLabelIfSelected);
            observer.observe(valueSpan, { childList: true, subtree: true });
            hideLabelIfSelected();
          }
        }
      }

      if (submitButton) {
        submitButton.addEventListener("click", function () {
          // Remove any previous custom error message
          const existingMsg = shadowRoot.getElementById("custom-mandatory-msg");
          if (existingMsg) existingMsg.remove();

          // Target the checkbox by name
          const newsOffersCheckbox = shadowRoot.querySelector(
            'input[type="checkbox"][name="custom#tick_here_to_receive_news_offers_and_exclusives"]'
          );
          if (newsOffersCheckbox && !newsOffersCheckbox.checked) {
            const msgDiv = document.createElement("div");
            msgDiv.id = "custom-mandatory-msg";
            const p = document.createElement("p");
            p.textContent = "*Please accept terms and conditions";
            p.style.color = "#d32f2f";
            p.style.margin = "0";
            p.style.fontWeight = "bold";
            msgDiv.appendChild(p);
            submitButton.parentNode.insertBefore(
              msgDiv,
              submitButton.nextSibling
            );
            return;
          }

          const hasError =
            shadowRoot.querySelector("._withError_1ydxd_16") ||
            shadowRoot.querySelector("._selectorError_1yit2_50");
          if (hasError) {
            const msgDiv = document.createElement("div");
            msgDiv.id = "custom-mandatory-msg";
            const p = document.createElement("p");
            p.textContent = "*Please fill all the mandatory fields";
            p.style.color = "#d32f2f";
            p.style.margin = "0";
            p.style.fontWeight = "bold";
            msgDiv.appendChild(p);
            submitButton.parentNode.insertBefore(
              msgDiv,
              submitButton.nextSibling
            );
          }
        });
      }

      if (submitButton) {
        // 1. Disable the button initially
        submitButton.disabled = true;
        submitButton.style.opacity = "0.4";
        submitButton.style.pointerEvents = "none";

        // 2. Function to check if all mandatory fields are filled
        function checkMandatoryFields() {
          const mandatorySelectors = [
            "#first_name",
            "#last_name",
            "#company_name",
            "#custom\\#postal_code",
            "#custom\\#towncity",
            "#phone_number",
          ];
          let allFilled = true;
          for (const sel of mandatorySelectors) {
            const el = shadowRoot.querySelector(sel);
            if (!el || !el.value || el.value.trim() === "") {
              allFilled = false;
              break;
            }
          }
          const newsOffersCheckbox = shadowRoot.querySelector(
            'input[type="checkbox"][name="custom#tick_here_to_receive_news_offers_and_exclusives"]'
          );
          if (!newsOffersCheckbox || !newsOffersCheckbox.checked) {
            allFilled = false;
          }
          submitButton.disabled = !allFilled;
          submitButton.style.opacity = allFilled ? "1" : "0.4";
          submitButton.style.pointerEvents = allFilled ? "auto" : "none";
        }

        // 3. Attach listeners to all mandatory fields
        const fieldsToWatch = [
          "#first_name",
          "#last_name",
          "#company_name",
          "#custom\\#postal_code",
          "#custom\\#towncity",
          "#phone_number",
          'input[type="checkbox"][name="custom#tick_here_to_receive_news_offers_and_exclusives"]',
        ];
        fieldsToWatch.forEach((sel) => {
          const el = shadowRoot.querySelector(sel);
          if (el) {
            el.addEventListener("input", checkMandatoryFields);
            el.addEventListener("change", checkMandatoryFields);
          }
        });

        // 4. Run check on load
        checkMandatoryFields();
      }

      // Apply .b2b_registration max-width and margin for screens wider than 1440px using JS
      function applyB2BRegistrationResponsive() {
        const b2bReg = document.querySelector(".b2b_registration");
        if (b2bReg) {
          if (window.innerWidth >= 1441) {
            b2bReg.style.maxWidth = "1440px";
            b2bReg.style.marginLeft = "auto";
            b2bReg.style.marginRight = "auto";
          } else {
            b2bReg.style.maxWidth = "";
            b2bReg.style.marginLeft = "";
            b2bReg.style.marginRight = "";
          }
        }
      }
      applyB2BRegistrationResponsive();
      window.addEventListener("resize", applyB2BRegistrationResponsive);

      // Hide .accountsContactName ._selectToggle_1yit2_25 p when a value is selected in the span
      const selectToggles = shadowRoot.querySelectorAll(
        ".accountsContactName ._selectToggle_1yit2_25"
      );
      selectToggles.forEach((toggle) => {
        const labelP = toggle.querySelector("p");
        const valueSpan = toggle.querySelector("span");
        if (labelP && valueSpan) {
          const observer = new MutationObserver(() => {
            if (valueSpan.textContent && valueSpan.textContent.trim() !== "") {
              labelP.style.display = "none";
            } else {
              labelP.style.display = "";
            }
          });
          observer.observe(valueSpan, { childList: true, subtree: true });
          if (valueSpan.textContent && valueSpan.textContent.trim() !== "") {
            labelP.style.display = "none";
          }
        }
      });

      // Add a custom class to the legend for easier targeting and hide it
      const legends = shadowRoot.querySelectorAll(
        "legend._textBody_2aowh_10._checkboxLegend_171zd_18"
      );
      legends.forEach((legend) => {
        legend.classList.add("custom-hide-legend");
        legend.style.display = "none";
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
